import React, { useMemo } from "react";
import { Tooltip } from "@material-ui/core";
import ApplicationConfigurationService, {
  IdentityApplicationSecretInfo,
} from "../services/ApplicationConfigurationService";
import { useSelector } from "react-redux";
import Submit from "modus/components/form/submit/Submit";
import AddIcon from "@material-ui/icons/Add";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import { ResourceAuthorizer } from "pages/home/authorizer/components/Authorizer";
import { useParams } from "react-router-dom";

interface ConsumerSecretCreatorProps {
  appName: string;
  onCreate: (value: IdentityApplicationSecretInfo) => void;
  disabled: boolean;
}
export const ConsumerSecretCreator: React.FC<ConsumerSecretCreatorProps> = ({
  appName,
  disabled = false,
  onCreate,
}) => {
  const identityEnvironment = useSelector(
    (state: any) => state?.common?.identityEnvironment
  );

  const { reset, state, subscribe } = useAsyncAction(() =>
    ApplicationConfigurationService.createSecret(identityEnvironment, appName)
  );

  const { id } = useParams<{ id: string }>();
  
  return useMemo(() => (
    <ResourceAuthorizer action="update" resourceType="APPLICATION" resourceId={id} hideErrorMessage>
    <Tooltip title="You can add up to 5 secrets" enterDelay={200}>
      <span>
        <Submit
          size="large"
          variant="outlined"
          color="primary"
          style={{ padding: "24px 21px" }}
          startIcon={<AddIcon />}
          state={state as any}
          onClick={() => subscribe()}
          onSuccess={(value: any)=>{
            onCreate(value);
            setTimeout(() => reset(), 200);
          }}
          disabled={disabled}
        >
          Add Secret
        </Submit>
      </span>
    </Tooltip>
    </ResourceAuthorizer>
  ),[subscribe, onCreate, disabled, reset, state, id]);
};
